import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, mergeMap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { SigninResponse } from '../signin-response.interface';
import { Signin } from '../signin.interface';
import * as redirectActions from './redirect.actions';
import * as reloadActions from '../reload/reload.actions';



@Injectable()
export class RedirectEffects {

  authenticateGame360$ = createEffect(() => this.actions$.pipe(
    ofType('[Redirect] Received Maxis SSO Token'),
    exhaustMap((action: {code: string}) => this.authService.postCodeToBackend(action.code)
      .pipe(
        map(signin => {
          if (signin.Message === 'User Not Confirm') {
            return ({type: '[Redirect] Customer Account Not Confirmed', data: {Token: signin.Token, UUID: signin.UUID}});
          } else if (signin.Success) {
            return ({type: '[Redirect] Authentication Successful', data: signin.UserInfo});
          } else {
            return ({type: '[Redirect] Failed To Authenticate'});
          }
        }),
        catchError(() => of({type: '[Redirect] Failed To Authenticate'})
      )
    )
  )));

  confirmNewUser$ = createEffect(() => this.actions$.pipe(
    ofType('[Header] Confirm Login'),
    exhaustMap((auth: {data: {Token: string; UUID: string; }}) => this.authService.confirmNewUser(auth.data)
    .pipe(
      map(signin => {
        if (signin.Success) {
          return ({type: '[Backend API] Confirm New User Successful', data: signin.UserInfo});
        } else {
          return ({type: '[Backend API] Confirm New User Not Successful'});
        }
      }),
      catchError(() => of({type: '[Backend API] Confirm New User Not Successful'}))
    ))
  ));

  fetchUserInfo$ = createEffect(() => this.actions$.pipe(
    ofType('[App] Start Apps'),
    exhaustMap(() => this.authService.userInfo()
    .pipe(
      map(signin => {
        if (signin.UUID) {
          return ({type: '[Backend API] Successfully fetched User Info', data: signin});
        } else {
          return ({type: '[Backend API] Failed to fetched User Info'});
        }
      }),
      catchError(() => of({type: '[Backend API] Failed to fetched User Info'}))
    ))
  ));

  reloadSuccessful$ = createEffect(() => this.actions$.pipe(
    ofType(reloadActions.loadReloadsSuccess),
    exhaustMap(() => this.authService.userInfo()
    .pipe(
      map(signin => {
        if (signin.UUID) {
          return ({type: '[Backend API] Successfully fetched User Info', data: signin});
        } else {
          return ({type: '[Backend API] Failed to fetched User Info'});
        }
      }),
      catchError(() => of({type: '[Backend API] Failed to fetched User Info'}))
    ))
  ));

  constructor(
    private actions$: Actions,
    private store: Store,
    private router: Router,
    private authService: AuthService) {}

}
